export default __webpack_public_path__ + "static/media/invite-friends-icon.1a05ce28.svg";